import { NetUserIDRisk } from "@/constants/netEvent.ts";
import { reqPost } from "@/service/clientRequest.ts";
import { GetUserIDVerificationStateResp } from "@/types/swagger/appserver.ts";
import { RequestFaceIndexPopInfoRsp } from "@/types/swagger/responsible.ts";
import {
  GetUserAuthV2Req,
  GetUserAuthV2Rsp,
  GetUserKycStatusReq,
  GetUserKycStatusRsp,
  RequestKycPopInfoReq,
  RequestKycPopInfoRsp,
} from "@/types/swagger/userIDRisk.ts";
import {
  GetFaceIndexResReq,
  GetFaceIndexResRsp,
} from "@/types/swaggerex/userIDRisk.ts";

/**
 * 每个操作节点检查kyc状态是否满足
 *
 * @class
 * @param data
 */
export async function GetUserAuthV2(data: GetUserAuthV2Req) {
  return reqPost<GetUserAuthV2Req, GetUserAuthV2Rsp>(
    data,
    NetUserIDRisk.mod,
    NetUserIDRisk.GetUserAuthV2,
    true,
  );
}

export async function GetUserKycStatus() {
  return reqPost<{}, GetUserKycStatusRsp>(
    {},
    NetUserIDRisk.mod,
    NetUserIDRisk.GetUserKycStatus,
    true,
  );
}

export async function GetUserIDVerificationState() {
  return reqPost<{}, GetUserIDVerificationStateResp>(
    {},
    NetUserIDRisk.mod,
    NetUserIDRisk.GetUserIDVerificationState,
    true,
  );
}

// 设置KYC信息
export async function RequestKycPopInfo(data: RequestKycPopInfoReq) {
  return reqPost<RequestKycPopInfoReq, RequestKycPopInfoRsp>(
    data,
    NetUserIDRisk.mod,
    NetUserIDRisk.RequestKycPopInfo,
    true,
  );
}

export async function RequestFaceIndexPopInfoFace(
  data: object,
  onError?: () => void,
) {
  return reqPost<{}, RequestFaceIndexPopInfoRsp>(
    data,
    NetUserIDRisk.mod,
    NetUserIDRisk.RequestFaceIndexPopInfo,
    true,
    undefined,
    onError,
  );
}

//
export async function ReportUserAuthData() {
  return reqPost<{}, unknown>(
    {},
    NetUserIDRisk.mod,
    NetUserIDRisk.ReportUserAuthData,
    true,
  );
}

// cpf找回密码，个人kyc状态
export async function GetFaceIndexRes(data: GetFaceIndexResReq) {
  return reqPost<GetFaceIndexResReq, GetFaceIndexResRsp>(
    data,
    NetUserIDRisk.mod,
    NetUserIDRisk.GetFaceIndexRes,
  );
}
